import { GridColDef } from "@mui/x-data-grid";
import type { PlatformPoliciesRow } from "../../hooks/usePlatformPoliciesTableData";
import { PolicyActionChip } from "~/components/PolicyActionChip";

export const PlatformPoliciesTableStatusCell: GridColDef<PlatformPoliciesRow>["renderCell"] =
  ({ row }) => {
    return <PolicyActionChip action={row.action} hideIcon />;
  };
